import { Pipe, PipeTransform, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { AbstractControl } from '@angular/forms';

@Pipe({
  name: 'formStatus',
  pure: false
})
export class FormStatusPipe implements PipeTransform, OnDestroy {
  private _subscription: Subscription;
  private _control: AbstractControl;
  private _lastValue: any;

  constructor(private _changeDetector: ChangeDetectorRef) {}

  ngOnDestroy() {
    this._dispose();
  }

  transform(obj: any, propertyName?: string): any {
    if(this._control !== obj ){
      this._dispose();
      this._control = obj;
      if(this._control && this._control.statusChanges) {
        this._subscription = this._control.statusChanges.subscribe(() => {
          if(this._lastValue !== (this._control ? this._control[propertyName] : null)){
            this._changeDetector.markForCheck();
          }
        });
      }
    }
    if(!propertyName) {
      return this._control;
    }
    this._lastValue = this._control ? this._control[propertyName] : null;
    return this._lastValue;
  }

  private _dispose() {
    if(this._subscription) {
      this._subscription.unsubscribe();
    }
    this._subscription = null;
    this._control = null;
    this._lastValue = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/common/pipes/form-status.pipe.ts